import { environment } from '@environments/environment';
import { CommonService } from '@shared/services/common.service';

/**
 * Builds the TopFans embed map URL (same contract as insights user segmentation map).
 * Safe to call only in a browser context (uses `document` for theme CSS variables).
 */
export function buildMapEmbedPageUrl(
  location: string | undefined,
  showRadius: boolean,
  cs: CommonService
): string {
  if (typeof document === 'undefined') {
    return '';
  }

  const body = document.body;
  const computedStyles = getComputedStyle(body);
  let configSecondaryBgColor = computedStyles
    .getPropertyValue('--configSecondaryBgColor')
    .trim();
  const configPostTextColor = computedStyles
    .getPropertyValue('--configPostTextColor')
    .trim();
  let configBgColor = computedStyles.getPropertyValue('--configBgColor').trim();
  const configBgTextColor = computedStyles
    .getPropertyValue('--configBgTextColor')
    .trim();

  if (!cs.isWhiteLabelWeb) {
    const theme = localStorage.getItem('theme');
    const secondaryBgTextColorMap: Record<string, string> = {
      'theme-default': '#002740',
      'theme-light': '#ffffff',
      'theme-dark': '#000000'
    };
    const bgColorMap: Record<string, string> = {
      'theme-default': '#1a3d53',
      'theme-light': '#ecf2f5',
      'theme-dark': '#424346'
    };
    configSecondaryBgColor = secondaryBgTextColorMap[theme] ?? configSecondaryBgColor;
    configBgColor = bgColorMap[theme] ?? configBgColor;
  }

  const whiteLabelTheme = encodeURIComponent(
    JSON.stringify({
      configSecondaryBgColor: configSecondaryBgColor,
      configPostTextColor: configBgTextColor,
      configBgColor: configBgColor,
      configBgTextColor: configPostTextColor
    })
  );
  const themeParam = 'theme-whiteLabel';

  return `${environment.EMBED_BASE_URL}map?theme=${themeParam}&parentUrl=${environment.websiteURL}&location=${location}&whiteLabelThemeData=${whiteLabelTheme}&showRadius=${showRadius}`;
}
